module.exports = __webpack_public_path__ + "img/img2.5e65b934.svg";